import {
  BtnBold,
  BtnClearFormatting,
  BtnItalic,
  BtnRedo,
  BtnStrikeThrough,
  BtnUnderline,
  BtnUndo,
  createDropdown,
  Editor,
  EditorProvider,
  Separator,
  Toolbar,
} from 'react-simple-wysiwyg';

import { labelNameToHtml } from '../../../../utils/labelText';

import '../../../spaces/Sidebar/Edit/react-simple-wysiwyg.scss';
import './LabelNameEditor.scss';

// Sizes relative to the label font size (see labelHtml)
const BtnSize = createDropdown('Size', [
  ['Small', 'fontSize', '2'],
  ['Normal', 'fontSize', '3'],
  ['Large', 'fontSize', '5'],
  ['Huge', 'fontSize', '6'],
]);

interface LabelNameEditorProps {
  value: string;
  onChange: (html: string) => void;
  placeholder?: string;
  'aria-label'?: string;
  'data-label-editor-primary-focus'?: string;
}

/** Formatted label name: lines, bold, italic, underline, strikethrough and sizes */
export function LabelNameEditor({ value, onChange, ...rest }: LabelNameEditorProps) {
  // Plain names (older labels) shown as HTML. Typed values don't change, keeping the caret
  const html = labelNameToHtml(value);

  return (
    <EditorProvider>
      <Editor
        {...rest}
        // Replaces the default container class
        containerProps={{ className: 'rsw-editor label-name-editor' }}
        value={html}
        onChange={(event) => onChange(event.target.value)}
      >
        <Toolbar>
          <BtnUndo />
          <BtnRedo />
          <Separator />
          <BtnBold />
          <BtnItalic />
          <BtnUnderline />
          <BtnStrikeThrough />
          <Separator />
          <BtnSize />
          <BtnClearFormatting />
        </Toolbar>
      </Editor>
    </EditorProvider>
  );
}
